




































import { AuthFactory } from "@/shared/api/auth";
import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { withTableauDashboards } from "@/employer/utilities/withTableauDashboards";
import MetricWithGraph from "@/employer/components/metric/MetricWithGraph.vue";
import MetricTabsWithContent from "@/employer/components/metric/MetricTabsWithContent.vue";
import { ProductPlanTab } from "@/employer/types";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    MetricWithGraph,
    MetricTabsWithContent,
  },
})
export default class MyProgramMetrics extends Vue {
  userStore = useUserStore();
  accessToken = AuthFactory.getAuth().accessToken();
  programHealthMetrics: any[] = [];
  programSnapshotMetrics: any[] = [];

  programHealthSelectors = [
    "HSA-ProgramHealth",
    "HRA-ProgramHealth",
    "HRARRA-ProgramHealth",
    "HRALSA-ProgramHealth",
    "HRAWellness-ProgramHealth",
    "FSAHC-ProgramHealth",
    "FSADC-ProgramHealth",
    "FSALP-ProgramHealth",
    "Parking-ProgramHealth",
    "Transit-ProgramHealth"
  ];
  programSnapshotSelectors = ["HSA-ProgramSnapshot", "FSA-ProgramSnapshot", "Commuter-ProgramSnapshot", "HRA-ProgramSnapshot"];

  async created () {
    this.programHealthMetrics = await this.userStore.getMetricsWithContent(this.programHealthSelectors);
    this.programSnapshotMetrics = await this.userStore.getMetricsWithContent(this.programSnapshotSelectors);
  }

  mounted () {
    withTableauDashboards();
  }

  get employerCode (): string {
    return this.userStore.currentEmployer.wexEmployerCode;
  }
}
